import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { LambdaService } from 'src/app/services/lambda.service';
import { SpinnerService } from 'src/app/services/spinner.service';

interface Shop {
  id: number;
  name: string;
}

interface SimulatorMessage {
  role: 'user' | 'ai';
  text: string;
  source?: string;
}

@Component({
  selector: 'app-agent-simulator',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule, InputTextModule, SelectModule, TooltipModule],
  templateUrl: './agent-simulator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentSimulatorComponent implements OnInit {
  shops: Shop[] = [];
  selectedShopId: number | null = null;

  messages: SimulatorMessage[] = [];
  input = '';
  isThinking = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private lambdaService: LambdaService,
    private spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    this.loadShops();
  }

  loadShops() {
    this.spinnerService.showSpinner();
    this.lambdaService.getShops().then(
      (data: any) => {
        const arr = Array.isArray(data) ? data : (data?.data || data?.shops || []);
        this.shops = arr.map((s: any) => ({ id: s.shopId, name: s.shopName }));
        this.spinnerService.hideSpinner();
        this.cdr.markForCheck();
      },
      () => {
        this.spinnerService.hideSpinner();
      }
    );
  }

  onShopChange(event: any) {
    this.selectedShopId = event.value;
    this.clearChat();
  }

  send() {
    const text = this.input.trim();
    if (!text || this.isThinking) return;

    this.messages = [...this.messages, { role: 'user', text }];
    this.input = '';
    this.isThinking = true;
    this.cdr.markForCheck();

    setTimeout(() => {
      this.messages = [
        ...this.messages,
        {
          role: 'ai',
          text: 'Esta funcionalidad estará disponible próximamente. Tu agente responderá aquí con base en el conocimiento que hayas cargado.',
          source: 'Base de conocimiento'
        }
      ];
      this.isThinking = false;
      this.cdr.markForCheck();
    }, 900);
  }

  clearChat() {
    this.messages = [];
    this.cdr.markForCheck();
  }
}
